import { Actor, CollisionType, ImageSource, Sprite } from "excalibur";
import { goToScene } from "../main";
import { Resources } from "../Resources";
import extractor from "./../../res/extractor.png";
export default class Extractor extends Actor {
  constructor(setCollision) {
    super({
      x: 15 * 16,
      y: 11 * 16,
      height: 22,
      width: 18,
      collisionType: CollisionType.Fixed,
      name: "extractorContainer",
      z: 5,
    });
    this.indicationShowing = false;
    this.extractorCollider = new Actor({
      width: 20,
      height: 24,
      collisionType: CollisionType.Passive,
      name: "extractorCollider",
    });
    let img = Resources.Extractor;
    let sprite = img.toSprite();
    this.graphics.add("extractor", sprite);

    this.addChild(this.extractorCollider);
    this.extractorCollider.on("collisionstart", (e) => {
      if (!this.indicationShowing && e.other.owner.name === "player") {
        console.log("collided with extractor");
        setCollision.setCollision(true, "extractor");
        this.createNotification();
      }
    });
    this.extractorCollider.on("collisionend", () => {
      if (this.indicationShowing) {
        setCollision.setCollision(false, "extractor");
        this.destroyNotification();
      }
    });
  }
  createNotification() {
    this.indicationShowing = true;
    this.noti = document.getElementById("hive-indication");
    this.noti.style.bottom = 0;
    this.noti.style.height = "60px";
    this.noti.style.padding = "10px";
    this.noti.style.display = "block";
    this.noti.innerHTML = `<p id="notification">Space: Extract</p>`;
  }
  destroyNotification() {
    this.indicationShowing = false;
    this.noti.innerHTML = ``;
    this.noti.style.bottom = "-400px";
    this.noti.style.display = "none";
  }
  onInitialize() {
    this.graphics.use("extractor");
  }
  onPostUpdate() {}
}
